import { render, staticRenderFns } from "./FollowUpDialog.vue?vue&type=template&id=a3bcb7ac&scoped=true"
import script from "./FollowUpDialog.vue?vue&type=script&lang=js"
export * from "./FollowUpDialog.vue?vue&type=script&lang=js"
import style0 from "./FollowUpDialog.vue?vue&type=style&index=0&id=a3bcb7ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bcb7ac",
  null
  
)

export default component.exports